import { createFileRoute } from "@tanstack/react-router";

import ApiKeys from "./-components/ApiKeys";

export const Route = createFileRoute("/_app/_dashboard/userapi/keys")({
  component: ApiKeys,
});
